import React from 'react'

/* Styles */
import './Schedule.css'

/**
 * Material UI
 */
import Avatar from 'material-ui/Avatar'
import { Spin } from 'antd'

const Schedule = (props) => {

    let schedules = props.schedules.map((schedule, index) => {
        return(
            <div className='ScheduleConfrontationLine' key={index} style={{ backgroundColor: (index % 2 === 0 ? 'rgb(241, 241, 241)' : null) }}>
                <div className='ScheduleConfrontationLineColumn' style={{ width: '10%' }}>
                    {schedule.id} &nbsp;
                </div>

                <div className='ScheduleConfrontationLineColumn'>
                    {schedule.idade ? schedule.idade : '-'}
                </div>

                <div className='ScheduleConfrontationLineColumn'>
                    {schedule.sexo ? schedule.sexo : '-'}
                </div>

                <div className='ScheduleConfrontationLineColumn' style={{ width: '10%' }}>
                    <Avatar
                        backgroundColor={schedule.faixa}
                        size={15}
                    ></Avatar>
                </div>

                <div className='ScheduleConfrontationLineColumn'>
                    {schedule.peso ? schedule.peso : '-'}
                </div>

                <div className='ScheduleConfrontationLineColumn'>
                    {schedule.hora} &nbsp;
                </div>

                <div style={{ clear: 'both' }}></div>
            </div>
        )
    })

    return(
        <div>
            <div className='ScheduleHeader'>
                <div className='ScheduleHeaderColumn' style={{ width: '10%' }}>
                    Chave
                </div>

                <div className='ScheduleHeaderColumn'>
                    Idade
                </div>

                <div className='ScheduleHeaderColumn'>
                    Sexo
                </div>

                <div className='ScheduleHeaderColumn' style={{ width: '10%' }}>
                    Faixa
                </div>

                <div className='ScheduleHeaderColumn'>
                    Peso
                </div>

                <div className='ScheduleHeaderColumn'>
                    Horário
                </div>

                <div style={{ clear: 'both' }}></div>
            </div>
            
            {
                props.loading ?
                    <Spin style={{ width: '100%', marginTop: '10px' }} />
                    :
                    schedules
            }
        </div>
    )
}

export default Schedule